module.exports = __webpack_public_path__ + "img/cv-template-11.8fa91668.png";